import Button from "@mui/material/Button";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import {
  IMuteNotificationOption,
  MUTE_NOTIFICATION_OPTIONS,
  useTranslation,
} from "hhn-commons";
import CommonDialog from "../../../common/CommonDialog/CommonDialog";

interface MuteNotificationsProps {
  closeModal: () => void;
  isModalOpen: boolean;
  onMute: () => void;
  setMuteDuration: (duration: IMuteNotificationOption) => void;
  muteDuration?: IMuteNotificationOption;
}

const MuteNotifications = ({
  isModalOpen,
  closeModal,
  onMute,
  setMuteDuration,
  muteDuration,
}: MuteNotificationsProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "settings" });

  return (
    <>
      <CommonDialog
        isDialogOpen={isModalOpen}
        onDialogClose={closeModal}
        title={tNs("muteNotifications")}
        titleAlignment="center"
        maxWidth="xs"
        actionContent={
          <Button
            variant="contained"
            color="primary"
            data-testid="confirm-button"
            onClick={onMute}
            disabled={!muteDuration}
          >
            {tNs("muteNotifications")}
          </Button>
        }
        children={
          <RadioGroup data-testid="mute-notifications-options">
            {MUTE_NOTIFICATION_OPTIONS.map(option => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio />}
                label={option.label}
                onClick={() => setMuteDuration(option)}
              />
            ))}
          </RadioGroup>
        }
      />
    </>
  );
};

export default MuteNotifications;
